module.exports = __webpack_public_path__ + "static/img/wh.1810bcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wh.jpg
// module id = JrB9
// module chunks = 1